{
  "title": "Fire Storm",
  "source": "Player's Handbook",
  "levelAndSchool": "7th-level evocation",
  "level": 7,
  "castingTime": "1 action",
  "range": "150 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "A storm made up of sheets of roaring flame appears in a location you choose within range. The area of the storm consists of up to ten 10-foot cubes, which you can arrange as you wish. Each cube must have at least one face adjacent to the face of another cube. Each creature in the area must make Dexterity saving throw. It takes 7d10 fire damage on a failed save, or half as much damage on a successful one.",
    "The fire damages objects in the area and ignites flammable objects that aren’t being worn or carried. If you choose, plant life in the area is unaffected by this spell."
  ],
  "spellLists": ["cleric", "druid", "sorcerer"]
}
